<template>
  <label :class="wrapClasses">
    <span :class="checkboxClasses">
      <span :class="innerClasses"></span>
        <input
          v-if="group"
          type="checkbox"
          :class="inputClasses"
          :disabled="disabled"
          :value="label"
          v-model="model"
          :name="name"
          @change="change"
          @focus="onFocus"
          @blur="onBlur">
          <input
            v-else
            type="checkbox"
            :class="inputClasses"
            :disabled="disabled"
            :checked="currentValue"
            :name="name"
            @change="change"
            @focus="onFocus"
            @blur="onBlur">
    </span>
    <slot :currentValue="currentValue">{{ label }}</slot>
  </label>
</template>

<script>
  import {findComponentUpward} from './../assist';
  import Emitter from './../emitter';

  const prefixCls = 'am-checkbox';
  export default {
    name: 'Checkbox',
    mixins: [Emitter],
    props: {
      value: {
        type: [String, Number, Boolean],
        default: false
      },
      label: {
        type: [String, Number, Boolean]
      },
      custom: {
        type: [Boolean],
        default: false
      },
      disabled: {
        type: [Boolean],
        default: false
      },
      name: {
        type: String
      }
    },
    created() {
    },
    data() {
      return {
        model: [],
        currentValue: this.value,
        group: false,
        trueValue: true,
        falseValue: false
      }
    },
    mounted() {
      this.parent = findComponentUpward(this, 'CheckboxGroup');
      this.group = !!this.parent;
      this.group && this.parent.update(true);
    },
    computed: {
      wrapClasses() {
        return [
          `${prefixCls}-wrapper`,
          {
            [`${prefixCls}-wrapper-disabled`]: this.disabled,
          }
        ]
      },
      checkboxClasses() {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}-checked`]: this.currentValue,
            [`${prefixCls}-disabled`]: this.disabled,
            [`${prefixCls}-indeterminate`]: this.indeterminate,
            [`${prefixCls}-custom`]: this.custom
          }
        ];
      },
      inputClasses() {
        return `${prefixCls}-input`;
      },
      innerClasses() {
        return [
          `${prefixCls}-inner`,
          {
            [`${prefixCls}-focus`]: this.focusInner
          }
        ];
      },
    },
    methods: {
      change(e) {
        if (this.disable) return false;
        const checked = e.target.checked;
        // this.currentValue = checked
        this.currentValue = checked;
        const value = checked ? this.trueValue : this.falseValue;
        this.$emit('input', value);
        if (this.group) {
          this.parent.change(this.model)
        } else {
          this.$emit('change', value)
        }
      },
      updateModel() {
        this.currentValue = this.value === this.trueValue;
      },
      onBlur() {
        this.focusInner = false;
      },
      onFocus() {
        this.focusInner = true;
      }
    },
    watch: {
      value(val) {
        if (val === this.trueValue || val === this.falseValue) {
          this.updateModel();
        } else {
          throw 'Value should be trueValue or falseValue.';
        }
      }
    },
    destroyed() {
    }
  }
</script>

<style lang="less">
  .am-checkbox-wrapper {
    display: inline-block;
    cursor: pointer;
    font-size: 12px;
    margin-right: 8px;
  }

  .am-checkbox + span, .am-checkbox-wrapper + span {
    margin-right: 4px;
  }

  .am-checkbox-disabled + span {
    color: #ccc;
    cursor: not-allowed;
  }

  .am-checkbox {
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
    line-height: 1;
    position: relative;
    margin-right: 4px;
  }

  .am-checkbox-disabled .am-checkbox-inner {
    background-color: #f3f3f3;
    border-color: #dcdee2;
  }

  .am-checkbox-checked .am-checkbox-inner {
    border-color: #2d8cf0;
    background-color: #2d8cf0;
    &:after {
      content: "";
      display: table;
      width: 4px;
      height: 8px;
      position: absolute;
      top: 1px;
      left: 4px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      -webkit-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      transition: all .2s ease-in-out;
    }
  }

  .am-checkbox-input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
  }

  .am-checkbox-custom {
    display: none;
  }

  .am-checkbox-inner {
    display: inline-block;
    width: 14px;
    height: 14px;
    position: relative;
    top: 0;
    left: 0;
    border: 1px solid #dcdee2;
    border-radius: 2px;
    background-color: #fff;
    transition: border-color .2s ease-in-out, background-color .2s ease-in-out, box-shadow .2s ease-in-out;
    &:after {
      content: "";
      display: table;
      width: 4px;
      height: 8px;
      position: absolute;
      top: 1px;
      left: 4px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      -webkit-transform: rotate(45deg) scale(0);
      transform: rotate(45deg) scale(0);
      transition: all .2s ease-in-out;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Checkbox/Checkbox.vue